import $ from 'jquery'
import Screen from './screen'
import { isActive, isOpen, isShow, breakpointMD } from '../_variables'

export default class TabContent {
  init() {
    $(function () {
      const $tabContent = $('.js-tab-content')
      const $tabButton = $('.js-tab-content .item .link')
      const isActive = 'is-active';

      if ($tabContent.length) {
        $tabButton.each((idx, ele) => {
          const $this = $(ele)
          const targetData = $this.data('content-tab')

          $this.on('click', (e) => {
            $(targetData).addClass(isActive)
            $tabButton.removeClass(isActive)
            $this.addClass(isActive)

            $('.c-tab-content-box').removeClass(isActive).removeAttr('style')
            $(`.c-tab-content-box[data-box-content='${targetData}']`).addClass(isActive)
          })
        })
      }
    })
  }
}